exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".inst{padding:5px;font-size:10px}.inst img{width:100%}.card-content{padding:10px}.mdl-card{margin:10px 0;width:calc(100% - 20px);margin:10px;break-inside:avoid}.mdl-card .mdl-card__title{padding:.5em 1em;font-size:18px}#app{-ms-grid-column:2;-webkit-column-count:2;column-count:2;column-gap:0}ul{padding-left:1em}.reference{font-size:12px}@media screen and (max-width:480px){.mdl-card{margin:10px 5px}#app{-ms-grid-column:1;-webkit-column-count:1;column-count:1}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-6481c87c!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 177
// module chunks = 0